
import { defineComponent, PropType } from 'vue'
import { iAlert, iListener } from '../AlertDefinition'
import Dropdown from 'primevue/dropdown'
import KnValidationMessages from '@/components/UI/KnValidatonMessages.vue'
import alertDescriptor from '../AlertDefinitionDescriptor.json'
export default defineComponent({
    name: 'name-card',
    components: { Dropdown, KnValidationMessages },
    props: {
        selectedAlert: {
            type: Object as PropType<iAlert>,
            required: false
        },
        listeners: {
            type: Array as PropType<iListener[]>,
            required: false
        },
        vcomp: Object
    },
    emits: ['touched', 'valueChanged'],
    watch: {
        selectedAlert() {
            this.alert = { ...this.selectedAlert }
        }
    },
    data() {
        return {
            alert: {} as iAlert,
            alertDescriptor
        }
    },
    methods: {
        valueChanged(fieldName: string, value: any) {
            this.$emit('valueChanged', { fieldName, value })
        }
    }
})
